import { render, staticRenderFns } from "./floatingActionButton.template?vue&type=template&id=672fe6f3&scoped=true&lang=pug&"
import script from "./floatingActionButton.client?vue&type=script&lang=ts&"
export * from "./floatingActionButton.client?vue&type=script&lang=ts&"
import style0 from "./floatingActionButton.style?vue&type=style&index=0&id=672fe6f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672fe6f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('672fe6f3')) {
      api.createRecord('672fe6f3', component.options)
    } else {
      api.reload('672fe6f3', component.options)
    }
    module.hot.accept("./floatingActionButton.template?vue&type=template&id=672fe6f3&scoped=true&lang=pug&", function () {
      api.rerender('672fe6f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/floatingActionButton/floatingActionButton.component.vue"
export default component.exports